import * as dotnet from './dotNet'
import moment from 'moment'
import * as aux from '../../../auxilaries'
import * as UI from './uiGenerators'
import { handleAPIErrors } from "../../../auxilaries";
import * as Net from "./dotNet";
import axios from 'axios';
import { RequestSource, RequestTypes } from '../../../Enums';
import { isPartialOfShift } from './PartialShiftHelper';
import { DateFnsFormats, formatAs } from '../../../../common-client2/src/services/ukgDateTime';
import { MomentFormats } from '../../../utils';
import { employeeDashboardStore as store } from '../../../store';

function poolData(context) {

    // TODO: Refactor suggestion,
    // 7 arrays should be combined into 1
    // Instead of arrays they should also be tagged with offerId
    let pool0 = []
    pool0.push(...context.props.storeData.employeeShiftOffers)
    pool0.push(...context.props.storeData.employeeMyShiftSwapOffers)
    pool0.push(...context.props.storeData.availableShiftToSwapOffers)
    pool0.push(...context.props.storeData.availableShiftsToCover)
    pool0.push(...context.props.storeData.myOpenShiftRequests)
    pool0.push(...context.props.storeData.myProposals)
    pool0.push(...context.props.storeData.myVTORequests)
    let pool1 = []
    pool1.push(...context.props.storeData.employeeShiftRequests)
    pool1.push(...context.props.storeData.privateOffers)
    pool1.push(...context.props.storeData.availableOpenShifts)

    return [pool0, pool1]
}
/**
 *
 * @param {Object} context Main state containing all data

 * @param {Object} raw raw shift information from backend
 */
export function historyItemClick(context, offerId) {
    // Pool all data into a global
    let [offers, requests] = poolData(context);
    let raw = offers.find(offer => offer.offerId === offerId || offer.id === offerId);
    if (raw) raw.source = RequestSource.Offerer
    else {
        raw = requests.find(offer => offer.offerId === offerId);
        raw.source = RequestSource.Requester;
    }
    if (raw.requestType) {
        raw.type = raw.requestType;
    }
    // 1. Bind click button with side panel
    context.handleShiftClick(
        {
            schedule: {
                raw: raw,
            }
        }, true
    )
}

export function handleDataRefresh(offer) {
    if (offer.raw.isPrivate) {
        refreshNotification.bind(this)(offer.offerId, false);
    }
    this.props.refreshData();
}


// TO COVER START
export async function handleRequestShift(offer, commentToManager, assignmentId = null) {
    const { options } = this.props;
    dotnet.loadAndHandle.bind(this)(
        dotnet.requestShiftToCover(options, offer.offerId, commentToManager, assignmentId),
        'Request was successfully sent',
        () => {
            refreshMyRequests.bind(this)(offer);
        }
    );
}

export async function handleRetractShiftOffer(offer) {
    const { options, managerSettings } = this.props;
    let setting = managerSettings.find(setting => setting.aggregateRootId === offer.raw.managerSettingAggregateRootId);
    dotnet.loadAndHandle.bind(this)(
        dotnet.retractMyToCoverOffer(options, offer.offerId),
        'Request ' + setting.name + ' was successfully retracted',
        () => {
            if (offer.raw.isPrivate) {
                refreshNotification.bind(this)(offer.offerId, false)
            }
            refreshRetractMyOffer.bind(this)(offer, true)
        }
    );
}

export async function handleRetractShiftRequest(offer) {
    const { options } = this.props;
    dotnet.loadAndHandle.bind(this)(
        dotnet.retractMyToCoverRequest(options, offer.offerId),
        'Request was successfully retracted',
        () => { refreshRetractMyRequest.bind(this)(offer) }
    );
}

export async function handlePartialOfferToCover(selectedManagerSetting, shifts, partialDates, employeesSelected, timeOffRequestSubtypeId, timeOffRequestReasonId) {
    const { options } = this.props
    let date = moment.utc(shifts[0].startDateTime).clone();

    let onlyPrivateIds = employeesSelected.map(ele => parseInt(ele.value));
    dotnet.loadAndHandle.bind(this)(
        dotnet.offerPartialToCover(options, shifts[0], selectedManagerSetting, partialDates.startDate, partialDates.endDate, onlyPrivateIds, timeOffRequestSubtypeId, timeOffRequestReasonId),
        onlyPrivateIds.length ? `Partial offer for ${selectedManagerSetting.name} was sent to ${employeesSelected.length} employee(s) with success` : `Partial ${selectedManagerSetting.name} was offered with success`,
        () => {
            refreshMyToCover.bind(this)(date, date);
            this.setState({
                partialDates: {
                    startDate: null,
                    endDate: null,
                },
                selectedPartialLabel: ''
            })
        }
    )
}

export async function handleOfferShiftToCover(selectedManagerSetting, shifts, partialDates, privateEmployeeSelected, timeOffRequestSubtypeId, timeOffRequestReasonId) {
    if (shifts.length === 1 && selectedManagerSetting.isPartialShiftEnabled) {
        if (isPartialOfShift(partialDates, shifts[0])) {
            handlePartialOfferToCover.bind(this)(selectedManagerSetting, shifts, partialDates, privateEmployeeSelected, timeOffRequestSubtypeId, timeOffRequestReasonId)
            this.props.clearSelectedShifts();
            return
        }
    }

    let shiftDates = shifts.map(d => moment.utc(d.startDateTime));
    let dateFrom = moment.min(shiftDates).clone();
    let dateTo = moment.max(shiftDates).clone();
    const { options } = this.props
    let onlyIds = privateEmployeeSelected.map(ele => parseInt(ele.value));
    dotnet.loadAndHandle.bind(this)(
        dotnet.offerShiftToCover(options, shifts, selectedManagerSetting, onlyIds, timeOffRequestSubtypeId, timeOffRequestReasonId),
        `${selectedManagerSetting.name} was offered with success`,
        () => {
            this.props.clearSelectedShifts();
            refreshMyToCover.bind(this)(dateFrom, dateTo);
        }
    )
}


export async function handleDeclineToCover(offerId) {
    const { options } = this.props
    dotnet.loadAndHandle.bind(this)(
        dotnet.declineToCoverOffer(options, offerId),
        'Request was successfully declined',
        () => {
            refreshNotification.bind(this)(offerId);
        }
    );
}


// TO COVER END
// SHIFT SWAP START
export async function handleSwapOfferShift(selectedManagerSetting, employeeSelected, preferredDatesSelected, shifts, partialDates) {
    const { options } = this.props;

    let employeeIds = employeeSelected.map(ele => parseInt(ele.value));
    let preferredDates = preferredDatesSelected.map(x => formatAs(x, DateFnsFormats.YMD));

    let shiftDates = shifts.map(d => moment.utc(d.startDateTime));
    let dateFrom = moment.min(shiftDates).clone();
    let dateTo = moment.max(shiftDates).clone();

    const isPartial = shifts.length === 1
        && selectedManagerSetting.isPartialShiftEnabled
        && isPartialOfShift(partialDates, shifts[0]);
    const message = employeeIds.length > 0 ? `${isPartial ? 'Partial offer' : 'Offer'} for ${selectedManagerSetting.name} was sent to ${employeeIds.length} employee(s) with success` : `${isPartial ? 'Partial' : ''} ${selectedManagerSetting.name} was offered with success`;

    dotnet.loadAndHandle.bind(this)(
        dotnet.offerShiftToSwap(
            options,
            shifts,
            selectedManagerSetting,
            employeeIds,
            preferredDates,
            isPartial ? partialDates.startDate : null,
            isPartial ? partialDates.endDate : null),
        message,
        () => {
            this.props.clearSelectedShifts();
            refreshMyShiftSwap.bind(this)(dateFrom, dateTo);
        }
    );
}

export async function handlePrivateSwapOfferShiftWithProposal(selectedManagerSetting, employeeSelected, shifts, shiftsToPropose, partialDates, proposalPartialDates) {
    const { options } = this.props;

    let shiftDates = shifts.map(d => moment.utc(d.startDateTime));
    let dateFrom = moment.min(shiftDates).clone();
    let dateTo = moment.max(shiftDates).clone();

    const isOfferedShiftPartial = shifts.length === 1
        && selectedManagerSetting.isPartialShiftEnabled
        && isPartialOfShift(partialDates, shifts[0]);
    const isProposalShiftPartial = shiftsToPropose.length === 1
        && isPartialOfShift(proposalPartialDates, shiftsToPropose[0]);

    const message = `${isOfferedShiftPartial ? 'Partial' : ''} ${selectedManagerSetting.name} was offered with success`;
    let partialStartDate, partialEndDate, proposalPartialStartDate, proposalPartialEndDate = null;
    if (isOfferedShiftPartial) {
        if (isProposalShiftPartial) {
            partialStartDate = partialDates.startDate;
            partialEndDate = partialDates.endDate;
            proposalPartialStartDate = proposalPartialDates.startDate;
            proposalPartialEndDate = proposalPartialDates.endDate;
        }
        else {
            partialStartDate = partialDates.startDate;
            partialEndDate = partialDates.endDate;
        }
    }

    if (isProposalShiftPartial) {
        proposalPartialStartDate = proposalPartialDates.startDate;
        proposalPartialEndDate = proposalPartialDates.endDate;
    }

    dotnet.loadAndHandle.bind(this)(
        dotnet.submitOfferWithProposal(options, shifts, selectedManagerSetting, employeeSelected, shiftsToPropose, partialStartDate, partialEndDate, proposalPartialStartDate, proposalPartialEndDate),
        message,
        () => {
            this.props.clearSelectedShifts();
            refreshMyShiftSwap.bind(this)(dateFrom, dateTo);
        }
    );
    return;
}

export async function handleSubmitProposal(offer, shiftsInfo, partialDates) {
    if (shiftsInfo.length === 0) {
        this.handleSnackbar('error', 'Select shift(s) to propose', true);
        return Promise.reject();
    }

    if (shiftsInfo.length !== offer.shifts.length) {
        this.handleSnackbar('error', 'The number of shifts offered must match the number of shifts proposed', true);
        return Promise.reject();
    }

    let proposalDates = shiftsInfo.map(d => moment.utc(d.startDateTime));
    let proposalFrom = moment.min(proposalDates).clone();
    let proposalTo = moment.max(proposalDates).clone();

    const isPartial = shiftsInfo.length === 1
        && isPartialOfShift(partialDates, shiftsInfo[0]);

    let partialStartDate, partialEndDate = null;
    if (isPartial) {
        partialStartDate = partialDates.startDate;
        partialEndDate = partialDates.endDate;
    }

    const { options } = this.props;
    dotnet.loadAndHandle.bind(this)(
        dotnet.submitProposal(options, offer.offerId, shiftsInfo, partialStartDate, partialEndDate),
        'Request proposal sent successfully',
        () => {
            if (offer.raw.isPrivate) {
                refreshNotification.bind(this)(offer.offerId, false, false);
            }
            refreshSubmitMyProposal.bind(this)(proposalFrom, proposalTo, offer);
        }
    );
}

export async function handleSubmitProposalFromOfferor(offer, proposal, commentToManager) {
    if (!proposal) {
        this.handleSnackbar('error', 'Select a proposal to accept', true);
        return;
    }
    let proposalDates = proposal.shifts.map(d => moment.utc(d.startDateTime));
    let proposalFrom = moment.min(proposalDates).clone();
    let proposalTo = moment.max(proposalDates).clone();

    const { options } = this.props;
    dotnet.loadAndHandle.bind(this)(
        dotnet.acceptOffer(options, offer.offerId, proposal.proposalId, commentToManager),
        'Request proposal sent successfully',
        () => {
            if (offer.raw.isPrivate) {
                refreshNotification.bind(this)(offer.offerId, false, false);
            }
            refreshSubmitMyProposal.bind(this)(proposalFrom, proposalTo, offer);
        }
    );
}

export async function handleRetractShiftSwapProposal(offer, proposalId) {
    const { options } = this.props;

    dotnet.loadAndHandle.bind(this)(
        dotnet.retractShiftSwapProposal(options, proposalId),
        'Proposal request succesfully retracted',
        () => {
            if (offer.raw.isPrivate) {
                refreshNotification.bind(this)(offer.offerId, false, false);
            }
            refreshRetractMyProposal.bind(this)(offer, proposalId);
        }
    )
}


export async function handleRetractShiftToSwapOffer(offer) {
    const { options } = this.props;

    // Use raw shift start dates (the day the offer/reporting is keyed to, e.g. Day 1 for an
    // overnight shift) and span every shift, so a multi-shift swap's reload window covers all
    // shifts including the earliest (= reporting.StartDate the backend filters on).
    let offerShiftDates = offer.raw.shifts.map(d => moment.utc(d.startDateTime));
    let offerDateFrom = moment.min(offerShiftDates).clone();
    let offerDateTo = moment.max(offerShiftDates).clone();
    dotnet.loadAndHandle.bind(this)(
        dotnet.handleRetractShiftToSwapOffer(options, offer.offerId),
        'Offer retracted',
        () => {
            if (offer.raw.isPrivate) {
                refreshNotification.bind(this)(offer.offerId, false, false);
            }
            refreshMyShiftSwap.bind(this)(offerDateFrom, offerDateTo);
        }
    );
}

export function handleAcceptProposal(context, pId, offer, commentToManager) {
    const { options } = context.props;
    dotnet.loadAndHandle.bind(context)(
        dotnet.acceptProposal(options, pId, offer.offerId, commentToManager),
        'Proposal accepted',
        () => {
            if (offer.raw.isPrivate) {
                refreshNotification.bind(context)(offer.offerId, false, true);
            }
            refreshHandleProposalAcceptOrReject.bind(context)(offer);
        }
    );
}

export function handleRejectProposal(context, pId, offer) {
    const { options } = context.props;
    dotnet.loadAndHandle.bind(context)(
        dotnet.declineProposal(options, pId, offer.offerId),
        'Proposal declined',
        () => {
            if (offer.raw.isPrivate) {
                refreshNotification.bind(context)(offer.offerId, false, true);
            }
            refreshHandleProposalAcceptOrReject.bind(context)(offer);
        }
    );
}

export async function handleDeclineShiftSwap(offerId) {
    const { options } = this.props;
    dotnet.loadAndHandle.bind(this)(
        dotnet.declineShiftSwapOffer(options, offerId),
        'Offer declined',
        () => {
            refreshNotification.bind(this)(offerId);
        }
    );
}

// SHIFT SWAP END
// OPEN SHIFT START
/**
 * @typedef {{
 *  key: string,
 *  startDate: Date,
 *  endDate: Date,
 *  managerSettingId: number,
 * }} IOpenShiftDetails
 * @param {IOpenShiftDetails[]} openShifts 
 * @param {string} commentToManager 
 * @param {boolean} isPartialShiftEnabled 
 * @param {{startDate: Date, endDate: Date}} partialDates
 * @param {string=} selectedAssignmentId
 */
export async function handleRequestOpenShift(openShifts, commentToManager, isPartialShiftEnabled, partialDates, selectedAssignmentId = null) { // TBD
    const { options } = this.props;
    let requests = []
    for (const openShift of openShifts) {
        requests.push({
            openShiftKey: openShift.key,
            managerSettingId: openShift.managerSettingId,
            startDate: openShift.startDate,
            endDate: openShift.endDate,
            selectedAssignmentId,
        })
    }
    if (openShifts.length === 1 && isPartialShiftEnabled) {
        if (!(moment.utc(partialDates.startDate).isSame(moment.utc(openShifts[0].startDate))
            && moment.utc(partialDates.endDate).isSame(moment.utc(openShifts[0].endDate)))) {
            const openShiftInfo = {
                ...requests[0],
                partialStartDate: partialDates.startDate,
                partialEndDate: partialDates.endDate,
                commentToManager,
            }
            dotnet.loadAndHandle.bind(this)(
                dotnet.submitPartialOpenShiftRequest(options, openShiftInfo),
                'Open shift request sent successfully',
                () => { refreshRequestOpenShift.bind(this)(openShifts) }
            );
            return;
        }
    }


    dotnet.loadAndHandle.bind(this)(
        dotnet.submitOpenShiftRequest(options, requests, commentToManager),
        'Open shift request sent successfully',
        () => { refreshRequestOpenShift.bind(this)(openShifts) }
    );
}

export async function handleRetractRequestOpenShift(requestId) { // TBD
    const { options } = this.props;
    dotnet.loadAndHandle.bind(this)(
        dotnet.retractMyOpenShiftRequest(options, requestId),
        'Open shift request retracted successfully',
        () => { refreshRetractRequestOpenShift.bind(this)(requestId) }
    );
}


// OPEN SHIFT END
// VOLUNTARY TIME OFF START

export async function handleRequestVTO(offerId, commentToManager, isPartial = false, partialDates = null) {
    const { options } = this.props;
    const partialStartDate = isPartial && partialDates ? partialDates.startDate : null;
    const partialEndDate = isPartial && partialDates ? partialDates.endDate : null;

    dotnet.loadAndHandle.bind(this)(
        dotnet.requestVTO(options, offerId, commentToManager, isPartial, partialStartDate, partialEndDate),
        'Successfully signed up for the voluntary time off',
        () => { refreshRequestVTO.bind(this)(offerId) }
    );
}

export async function handleRetractRequestVTO(offerId) { // TBD
    const { options } = this.props;
    dotnet.loadAndHandle.bind(this)(
        dotnet.retractVTORequest(options, offerId),
        'Successfully retracted voluntary time off request',
        () => { refreshRetractRequestVTO.bind(this)(offerId) }
    );
}

// VOLUNTARY TIME OFF END




export async function handleDismissAllButton() {
    const { updateLoading, options, storeData, updateEmployeeDashboardData } = this.props;
    updateLoading(true)
    dotnet.DismissAll(options).then(async response => {
        let payload = { privateOffers: [] }

        let dismissedCount = storeData.privateOffers.filter(x => x.isNew).length
        if (dismissedCount) {//decrement private notif count
            let privateOffersSummary = storeData.privateOffersSummary
            privateOffersSummary.new -= dismissedCount
            payload.privateOffersSummary = privateOffersSummary
        }
        await updateEmployeeDashboardData(payload)
        updateEmployeeDashboardData(payload)
    }).catch(err => {
        let message = aux.handleAPIErrors(err.response)
        this.handleSnackbar('error', message, true)
    }).finally(() => {
        this.props.updateLoading(false)
    })
}

export async function refreshNotification(offerId, isUpdateLoading = true, isIncreaseCount = false) {//fetch single request
    let { updateEmployeeDashboardData, updateLoading, storeData } = this.props;
    const { options } = this.props

    let privateOffer = storeData.privateOffers.find(x => x.offerId === offerId);
    if (privateOffer) {
        dotnet.retrievePrivateOffers([privateOffer.offerGuid], options).then(async privateOffersResponse => {
            let privateOffers = storeData.privateOffers;

            let index = privateOffers.findIndex(x => x.offerId === offerId)
            if (index !== -1) {
                if (privateOffersResponse.data.offers && privateOffersResponse.data.offers.length) {
                    let updateOffer = privateOffersResponse.data.offers[0]
                    privateOffers[index] = updateOffer
                }
                else {//if no offer returned, this means it was dismissed
                    privateOffers.splice(index, 1)
                }

                let payload = {
                    privateOffers: privateOffers
                }

                if (isIncreaseCount) {
                    let privateOffersSummary = storeData.privateOffersSummary
                    privateOffersSummary.new++
                    payload.privateOffersSummary = privateOffersSummary
                }
                await updateEmployeeDashboardData(payload);
            }
            if (isUpdateLoading) {
                updateLoading(false)
            }
        }).catch(err => {
            let message = aux.handleAPIErrors(err.response)
            this.handleSnackbar('error', message, true)
            if (isUpdateLoading) {
                updateLoading(false)
            }
        })
    }
}

export async function loadNextNotifications() {
    const { storeData, options, updateEmployeeDashboardData } = this.props;
    const nbToLoad = 10; // TODO PUT THIS SOMEWHERE ELSE

    this.props.updateLoading(true)

    let summary = storeData.privateOffersSummary;
    let nextToBeLoaded = summary.offerIds;

    if (summary.loadedIds.length) {
        nextToBeLoaded = summary.offerIds.filter(x => !summary.loadedIds.includes(x))
    }

    nextToBeLoaded = nextToBeLoaded.slice(0, nbToLoad);

    if (nextToBeLoaded.length) {
        dotnet.retrievePrivateOffers(nextToBeLoaded, options)
            .then(async privateOffersResponse => {
                summary.loadedIds = summary.loadedIds.concat(nextToBeLoaded)
                let payload = {
                    privateOffersSummary: summary,
                    privateOffers: [...storeData.privateOffers, ...privateOffersResponse.data.offers]
                }

                await updateEmployeeDashboardData(payload);
            })
            .catch(err => {
                let message = aux.handleAPIErrors(err.response)
                this.props.updateSnackbar({
                    typeSnackbar: 'error',
                    messageSnackbar: message,
                    openSnackbar: true,
                })
            }).finally(() => {
                this.props.updateLoading(false);
            })
    } else {
        this.props.updateLoading(false);
    }
}

export async function markAsViewed(requestType, offerId, proposalId = null) {
    const { updateSnackbar, person, options, storeData, updateEmployeeDashboardData } = this.props

    switch (requestType) {
        case RequestTypes.toCover:
            dotnet.MarkAsViewed(options, offerId, proposalId).then(() => {
                let privateOffer = storeData.privateOffers.find(ele => ele.offerId === offerId);
                let summary = storeData.privateOffersSummary;
                let wasNew = privateOffer.isNew;
                privateOffer.isNew = false

                if (wasNew) {
                    summary.new--;
                }

                updateEmployeeDashboardData({ privateOffers: storeData.privateOffers, privateOffersSummary: summary })
            }).catch(err => {
                let message = handleAPIErrors(err.response)
                updateSnackbar({
                    typeSnackbar: 'error',
                    messageSnackbar: message,
                    openSnackbar: true,
                })
            })
            break;
        case RequestTypes.shiftSwap:
            dotnet.MarkAsViewed(options, offerId, proposalId)
                .then(markAsViewedResponse => {
                    let privateOffer = storeData.privateOffers.find(ele => ele.offerId === offerId);
                    let summary = storeData.privateOffersSummary;
                    let wasNew = privateOffer.isNew;

                    privateOffer.isNew = false

                    if (person.currentEmployeeId === privateOffer.employeeFromId) {
                        for (let proposal of privateOffer.proposals) {
                            wasNew = wasNew || proposal.isNew;
                            proposal.isNew = false
                        }
                    }

                    if (wasNew) {
                        summary.new--;
                    }

                    updateEmployeeDashboardData({ privateOffers: storeData.privateOffers, privateOffersSummary: summary })
                }).catch(err => {
                    let message = handleAPIErrors(err.response)
                    updateSnackbar({
                        typeSnackbar: 'error',
                        messageSnackbar: message,
                        openSnackbar: true,
                    })
                })
            break;
        case RequestTypes.voluntaryTimeOff:
            dotnet.MarkAsViewed(options, null, null, offerId).then(() => {
                let privateOffer = storeData.privateOffers.find(ele => ele.offerId === offerId);
                let summary = storeData.privateOffersSummary;
                let wasNew = privateOffer.isNew;
                privateOffer.isNew = false
                if (wasNew) {
                    summary.new--;
                }

                updateEmployeeDashboardData({ privateOffers: storeData.privateOffers, privateOffersSummary: summary })
            }).catch(err => {
                let message = handleAPIErrors(err.response)
                updateSnackbar({
                    typeSnackbar: 'error',
                    messageSnackbar: message,
                    openSnackbar: true,
                })
            })
            break;
        default:
            break;
    }
}

export async function handleDismissButton(oId, pId, isVTO) {
    const { options, storeData, updateEmployeeDashboardData,updateLoading } = this.props
    updateLoading(true)
    let offerId = oId, proposalId = pId, vtoId = null;
    if (isVTO) {
        offerId = null
        proposalId = null
        vtoId = oId
    }

    dotnet.Dismiss(options, offerId, proposalId, vtoId)
        .then(async response => {
            let offerToDismiss = storeData.privateOffers.find(x => x.offerId === oId)
            let privateOffers = storeData.privateOffers.filter(x => x.offerId !== oId)
            let payload = { privateOffers: privateOffers }
            if (offerToDismiss && offerToDismiss.isNew) {//decrement private notif count
                let privateOffersSummary = storeData.privateOffersSummary
                privateOffersSummary.new--
                payload.privateOffersSummary = privateOffersSummary
            }
            await updateEmployeeDashboardData(payload)
        })
        .catch(err => {
            let message = aux.handleAPIErrors(err.response)
            handleSnackbar.bind(this)('error', message, true)
        })
        .finally(() => {
            updateLoading(false);
        })
}

export function handleSnackbar(type, message, openState) {
    this.props.updateSnackbar({
        typeSnackbar: type,
        messageSnackbar: message,
        openSnackbar: openState,
    })
}

async function refreshMyToCover(dateFrom, dateTo) {
    const { options, statusDictionary, dateRanges, managerSettings, person, updateLoading, storeData, updateEmployeeDashboardData } = this.props;
    const { globalConfigs } = store.getState();
    dotnet.getMyShiftOffersToCover(options, dateFrom.format(MomentFormats.YMD), dateTo.format(MomentFormats.YMD)).then(async response => {
        if (response.data && response.data.length) {

            let myOffers = storeData.employeeShiftOffers;
            for (const toCover of response.data) {
                let index = myOffers.findIndex(x => x.offerId === toCover.offerId);
                if (index !== -1) {
                    myOffers[index] = toCover;
                } else {
                    myOffers.push(toCover);
                }
            }

            let monthlySchedule = UI.generateSchedule(true,
                storeData.employeeShifts,
                myOffers,
                storeData.availableShiftsToCover,
                storeData.employeeShiftRequests,
                storeData.employeeMyShiftSwapOffers,
                storeData.availableShiftToSwapOffers,
                storeData.employeePaycodes,
                storeData.myProposals,
                storeData.availableOpenShifts,
                storeData.myOpenShiftRequests,
                storeData.availableVTO,
                storeData.myVTORequests,
                statusDictionary,
                person.personName,
                managerSettings,
                dateRanges,
                globalConfigs.postedRequestDisplay,
            )

            await updateEmployeeDashboardData({
                monthlySchedule: monthlySchedule,
                employeeShiftOffers: myOffers
            });
        }

    }).catch(err => {
        let message = aux.handleAPIErrors(err.response)
        handleSnackbar.bind(this)('error', message, true)
    }).finally(() => {
        updateLoading(false);
    });
}

export async function refreshMyRequests(offer) {
    let { options, updateLoading, updateEmployeeDashboardData, storeData, statusDictionary, managerSettings, person, dateRanges } = this.props;
    const { globalConfigs } = store.getState();
    let dateToReload;
    let availableShiftsToCover = storeData.availableShiftsToCover

    //1. refresh available TC offers
    if (offer.raw.isPrivate) {
        refreshNotification.bind(this)(offer.offerId, false, true)
        dateToReload = formatAs(offer.raw.shifts[0].startDateTime, DateFnsFormats.YMD);
    } else {
        //remove offer from available offers
        dateToReload = formatAs(offer.raw.shift.startDateTime, DateFnsFormats.YMD);
        availableShiftsToCover = availableShiftsToCover.filter(x => x.offerId !== offer.offerId)
    }

    //2. refresh my requests
    Net.getMyShiftRequestsToCover(options, dateToReload, dateToReload).then(async employeeShiftRequestsResponse => {
        if (!employeeShiftRequestsResponse.data || !employeeShiftRequestsResponse.data.length) {
            return;
        }

        let allMyRequests = storeData.employeeShiftRequests
        for (const toCover of employeeShiftRequestsResponse.data) {
            let existingRequestIndex = allMyRequests.findIndex(x => x.offerId === toCover.offerId);
            if (existingRequestIndex !== -1) {
                allMyRequests[existingRequestIndex] = toCover
            } else {
                allMyRequests.push(toCover)
            }
        }

        let monthlySchedule = UI.generateSchedule(true,
            storeData.employeeShifts,
            storeData.employeeShiftOffers,
            availableShiftsToCover,
            allMyRequests,
            storeData.employeeMyShiftSwapOffers,
            storeData.availableShiftToSwapOffers,
            storeData.employeePaycodes,
            storeData.myProposals,
            storeData.availableOpenShifts,
            storeData.myOpenShiftRequests,
            storeData.availableVTO,
            storeData.myVTORequests,
            statusDictionary,
            person.personName,
            managerSettings,
            dateRanges,
            globalConfigs.postedRequestDisplay,
        )

        await updateEmployeeDashboardData({
            availableShiftsToCover: availableShiftsToCover,
            employeeShiftRequests: allMyRequests,
            monthlySchedule: monthlySchedule
        })
    }).catch(err => {
        let message = aux.handleAPIErrors(err.response)
        handleSnackbar.bind(this)('error', message, true)
    }).finally(() => {
        updateLoading(false);
    });
}

export async function refreshRetractMyOffer(offer) {
    let { options, updateLoading, updateEmployeeDashboardData, storeData, statusDictionary, managerSettings, person, dateRanges } = this.props;
    const { globalConfigs } = store.getState();
    const dateToReload = formatAs(offer.raw.shift.startDateTime, DateFnsFormats.YMD);

    await Net.getMyShiftOffersToCover(options, dateToReload, dateToReload).then(async employeeShiftOffersResponse => {
        if (!employeeShiftOffersResponse.data || !employeeShiftOffersResponse.data.length) {
            return;
        }

        let allMyOffers = storeData.employeeShiftOffers
        for (const toCover of employeeShiftOffersResponse.data) {
            let index = allMyOffers.findIndex(x => x.offerId === toCover.offerId);
            if (index !== -1) {
                allMyOffers[index] = toCover;
            } else {//this should not happen
                allMyOffers.push(toCover);
            }
        }

        let monthlySchedule = UI.generateSchedule(true,
            storeData.employeeShifts,
            allMyOffers,
            storeData.availableShiftsToCover,
            storeData.employeeShiftRequests,
            storeData.employeeMyShiftSwapOffers,
            storeData.availableShiftToSwapOffers,
            storeData.employeePaycodes,
            storeData.myProposals,
            storeData.availableOpenShifts,
            storeData.myOpenShiftRequests,
            storeData.availableVTO,
            storeData.myVTORequests,
            statusDictionary,
            person.personName,
            managerSettings,
            dateRanges,
            globalConfigs.postedRequestDisplay,
        )

        await updateEmployeeDashboardData({
            employeeShiftOffers: allMyOffers,
            monthlySchedule: monthlySchedule
        });

    }).catch(err => {
        let message = aux.handleAPIErrors(err.response);
        handleSnackbar.bind(this)('error', message, true)
    }).finally(() => {
        updateLoading(false);
    });
}


export async function refreshRetractMyRequest(offer) {
    let { options, updateLoading, updateEmployeeDashboardData, storeData, statusDictionary, managerSettings, person, dateRanges } = this.props;
    const { globalConfigs } = store.getState();
    try {
        let dateToReload;
        let monthlySchedule = storeData.monthlySchedule
        let allMyRequests = storeData.employeeShiftRequests
        let availableShiftsToCover = storeData.availableShiftsToCover

        //1. refresh available TC offers
        if (offer.raw.isPrivate) { // could open from PrivateOffer(raw.shifts) or from MyRequest(raw.shift)
            refreshNotification.bind(this)(offer.offerId, false, true)
            dateToReload = formatAs(offer.shifts[0].startDateTime, DateFnsFormats.YMD);
        }
        else {
            //add offer from available offers and monthlySchedule
            dateToReload = formatAs(offer.raw.shift.startDateTime, DateFnsFormats.YMD);

            await Net.getAvailableShiftToCoverOffers(options, dateToReload, dateToReload, 1).then(async availableShiftToCoverOffersResponse => {
                if (!availableShiftToCoverOffersResponse.data || !availableShiftToCoverOffersResponse.data.offers.length) {
                    return;
                }

                for (const toCover of availableShiftToCoverOffersResponse.data.offers) {
                    let index = availableShiftsToCover.findIndex(x => x.offerId === toCover.offerId);
                    if (index !== -1) {
                        availableShiftsToCover[index] = toCover;
                    } else {
                        availableShiftsToCover.push(toCover);
                    }
                }
            })
        }

        //2. refresh my requests
        await Net.getMyShiftRequestsToCover(options, dateToReload, dateToReload).then(async employeeShiftRequestsResponse => {
            if (!employeeShiftRequestsResponse.data || !employeeShiftRequestsResponse.data.length) {
                return;
            }


            for (const toCover of employeeShiftRequestsResponse.data) {
                let existingRequestIndex = allMyRequests.findIndex(x => x.offerId === toCover.offerId);
                if (existingRequestIndex !== -1) {
                    allMyRequests[existingRequestIndex] = toCover
                } else {
                    allMyRequests.push(toCover)
                }
            }

            monthlySchedule = UI.generateSchedule(true,
                storeData.employeeShifts,
                storeData.employeeShiftOffers,
                storeData.availableShiftsToCover,
                allMyRequests,
                storeData.employeeMyShiftSwapOffers,
                storeData.availableShiftToSwapOffers,
                storeData.employeePaycodes,
                storeData.myProposals,
                storeData.availableOpenShifts,
                storeData.myOpenShiftRequests,
                storeData.availableVTO,
                storeData.myVTORequests,
                statusDictionary,
                person.personName,
                managerSettings,
                dateRanges,
                globalConfigs.postedRequestDisplay,
            )
        })

        // 3. update store
        await updateEmployeeDashboardData({
            employeeShiftRequests: allMyRequests,
            monthlySchedule: monthlySchedule,
            availableShiftsToCover: availableShiftsToCover
        });
    } finally {
        updateLoading(false);
    }
}

async function refreshMyShiftSwap(dateFrom, dateTo) {
    const { options, statusDictionary, dateRanges, managerSettings, person, updateLoading, storeData, updateEmployeeDashboardData } = this.props;
    const { globalConfigs } = store.getState();
    dotnet.getMyShiftSwapOffers(options, dateFrom.format(MomentFormats.YMD), dateTo.format(MomentFormats.YMD)).then(async response => {
        if (response.data && response.data.length) {

            let myOffers = storeData.employeeMyShiftSwapOffers;
            for (const swapOffer of response.data) {
                let index = myOffers.findIndex(x => x.offerId === swapOffer.offerId);
                if (index !== -1) {
                    myOffers[index] = swapOffer;
                } else {
                    myOffers.push(swapOffer);
                }
            }

            let monthlySchedule = UI.generateSchedule(true,
                storeData.employeeShifts,
                storeData.employeeShiftOffers,
                storeData.availableShiftsToCover,
                storeData.employeeShiftRequests,
                myOffers,
                storeData.availableShiftToSwapOffers,
                storeData.employeePaycodes,
                storeData.myProposals,
                storeData.availableOpenShifts,
                storeData.myOpenShiftRequests,
                storeData.availableVTO,
                storeData.myVTORequests,
                statusDictionary,
                person.personName,
                managerSettings,
                dateRanges,
                globalConfigs.postedRequestDisplay,
            );

            await updateEmployeeDashboardData({
                monthlySchedule: monthlySchedule,
                employeeMyShiftSwapOffers: myOffers
            });
        }

    }).catch(err => {
        let message = aux.handleAPIErrors(err.response)
        handleSnackbar.bind(this)('error', message, true)
    }).finally(() => {
        updateLoading(false);
    });
}



async function refreshSubmitMyProposal(dateFrom, dateTo, offer) {
    const { options, statusDictionary, dateRanges, managerSettings, person, updateLoading, storeData, updateEmployeeDashboardData } = this.props;
    const { globalConfigs } = store.getState();

    dotnet.getMySwapProposals(options, dateFrom.format(MomentFormats.YMD), dateTo.format(MomentFormats.YMD)).then(async response => {
        if (response.data && response.data.length) {

            let myProposals = storeData.myProposals;
            for (const swapProposal of response.data) {
                let index = myProposals.findIndex(x => x.offerId === swapProposal.offerId);
                if (index !== -1) {
                    myProposals[index] = swapProposal;
                } else {
                    myProposals.push(swapProposal);
                }
            }

            let swapOffers = storeData.availableShiftToSwapOffers.filter(x => x.offerId !== offer.offerId);

            let monthlySchedule = UI.generateSchedule(true,
                storeData.employeeShifts,
                storeData.employeeShiftOffers,
                storeData.availableShiftsToCover,
                storeData.employeeShiftRequests,
                storeData.employeeMyShiftSwapOffers,
                swapOffers,
                storeData.employeePaycodes,
                myProposals,
                storeData.availableOpenShifts,
                storeData.myOpenShiftRequests,
                storeData.availableVTO,
                storeData.myVTORequests,
                statusDictionary,
                person.personName,
                managerSettings,
                dateRanges,
                globalConfigs.postedRequestDisplay,
            );

            await updateEmployeeDashboardData({
                monthlySchedule: monthlySchedule,
                myProposals: myProposals,
                availableShiftToSwapOffers: swapOffers
            });
        }

    }).catch(err => {
        let message = aux.handleAPIErrors(err.response)
        handleSnackbar.bind(this)('error', message, true)
    }).finally(() => {
        updateLoading(false);
    });
}


async function refreshRetractMyProposal(offer, proposalId) {
    const { options, statusDictionary, dateRanges, managerSettings, person, updateLoading, storeData, updateEmployeeDashboardData } = this.props;
    const { globalConfigs } = store.getState();

    let proposal = offer.proposals.find(x => x.proposalId === proposalId);
    let proposalShiftDates = proposal.shifts.map(d => moment.utc(d.startDateTime));
    let proposalDateFrom = moment.min(proposalShiftDates);
    let proposalDateTo = moment.max(proposalShiftDates);

    let offerShiftDates = offer.shifts.map(d => moment(d.startDateTime));
    let offerDateFrom = moment.min(offerShiftDates);
    let offerDateTo = moment.max(offerShiftDates);

    await axios.all([
        dotnet.getMySwapProposals(options, proposalDateFrom.format(MomentFormats.YMD), proposalDateTo.format(MomentFormats.YMD)),
        dotnet.getAvailableShiftToSwapOffers(options, offerDateFrom.format(MomentFormats.YMD), offerDateTo.format(MomentFormats.YMD))
    ]).then(axios.spread(async (
        mySwapProposalsResponse,
        shiftSwapOffersResponse
    ) => {

        let myProposals = storeData.myProposals;
        for (const swapProposal of mySwapProposalsResponse.data) {
            let index = myProposals.findIndex(x => x.offerId === swapProposal.offerId);

            if (index !== -1) {
                myProposals[index] = swapProposal;
            } else {
                myProposals.push(swapProposal);
            }
        }

        let shiftSwapOffers = storeData.availableShiftToSwapOffers;
        for (const swapOffers of shiftSwapOffersResponse.data.offers) {
            let index = shiftSwapOffers.findIndex(x => x.offerId === swapOffers.offerId);
            if (index !== -1) {
                shiftSwapOffers[index] = swapOffers;
            } else {
                shiftSwapOffers.push(swapOffers);
            }
        }

        let monthlySchedule = UI.generateSchedule(true,
            storeData.employeeShifts,
            storeData.employeeShiftOffers,
            storeData.availableShiftsToCover,
            storeData.employeeShiftRequests,
            storeData.employeeMyShiftSwapOffers,
            shiftSwapOffers,
            storeData.employeePaycodes,
            myProposals,
            storeData.availableOpenShifts,
            storeData.myOpenShiftRequests,
            storeData.availableVTO,
            storeData.myVTORequests,
            statusDictionary,
            person.personName,
            managerSettings,
            dateRanges,
            globalConfigs.postedRequestDisplay,
        );

        await updateEmployeeDashboardData({
            monthlySchedule: monthlySchedule,
            myProposals: myProposals,
            availableShiftToSwapOffers: shiftSwapOffers
        });
    })).catch(err => {
        let message = aux.handleAPIErrors(err.response)
        this.props.updateSnackbar({
            typeSnackbar: 'error',
            messageSnackbar: message,
            openSnackbar: true,
        })
    }).finally(() => {
        updateLoading(false);
    });
}

export function refreshHandleProposalAcceptOrReject(offer) {
    const { options, statusDictionary, dateRanges, managerSettings, person, updateLoading, storeData, updateEmployeeDashboardData } = this.props;
    const { globalConfigs } = store.getState();
    let offerDates = offer.shifts.map(d => moment(d.startDateTime));
    let dateToReloadMin = moment.min(offerDates);
    let dateToReloadMax = moment.max(offerDates);
    dotnet.getMyShiftSwapOffers(options, dateToReloadMin.format(MomentFormats.YMD), dateToReloadMax.format(MomentFormats.YMD)).then(async employeeMyShiftSwapOffersResponse => {
        if (employeeMyShiftSwapOffersResponse.data && employeeMyShiftSwapOffersResponse.data.length) {

            let employeeMyShiftSwapOffers = storeData.employeeMyShiftSwapOffers;
            for (const myOffer of employeeMyShiftSwapOffersResponse.data) {
                let index = employeeMyShiftSwapOffers.findIndex(x => x.offerId === myOffer.offerId);
                if (index !== -1) {
                    employeeMyShiftSwapOffers[index] = myOffer;
                } else {
                    employeeMyShiftSwapOffers.push(myOffer);
                }
            }

            let monthlySchedule = UI.generateSchedule(true,
                storeData.employeeShifts,
                storeData.employeeShiftOffers,
                storeData.availableShiftsToCover,
                storeData.employeeShiftRequests,
                employeeMyShiftSwapOffers,
                storeData.availableShiftToSwapOffers,
                storeData.employeePaycodes,
                storeData.myProposals,
                storeData.availableOpenShifts,
                storeData.myOpenShiftRequests,
                storeData.availableVTO,
                storeData.myVTORequests,
                statusDictionary,
                person.personName,
                managerSettings,
                dateRanges,
                globalConfigs.postedRequestDisplay,
            );

            await updateEmployeeDashboardData({
                monthlySchedule: monthlySchedule,
                employeeMyShiftSwapOffers: employeeMyShiftSwapOffers
            });
        }
    }).catch(err => {
        let message = aux.handleAPIErrors(err.response)
        handleSnackbar.bind(this)('error', message, true)
    }).finally(() => {
        updateLoading(false);
    });
}

export async function refreshRequestOpenShift(openShifts) {
    const { options, statusDictionary, dateRanges, managerSettings, person, updateLoading, storeData, updateEmployeeDashboardData } = this.props;
    const { globalConfigs } = store.getState();

    let openShiftDates = openShifts.map(d => moment(d.startDate));
    let openShiftFrom = moment.min(openShiftDates);
    let openShiftTo = moment.max(openShiftDates);

    dotnet.getMyOpenShiftRequests(options, openShiftFrom.format(MomentFormats.YMD), openShiftTo.format(MomentFormats.YMD)).then(async myOpenShiftRequestsResponse => {
        if (!myOpenShiftRequestsResponse.data || !myOpenShiftRequestsResponse.data.length) {
            return this.props.refreshData()
        }

        let openShiftRequests = storeData.myOpenShiftRequests;
        for (const openShift of myOpenShiftRequestsResponse.data) {
            let index = openShiftRequests.findIndex(x => x.id === openShift.id);
            if (index !== -1) {//2nd, 3rd request => replace
                openShiftRequests[index] = openShift;
            }
            else {//first request => push
                openShiftRequests.push(openShift);
            }
        }

        let monthlySchedule = UI.generateSchedule(true,
            storeData.employeeShifts,
            storeData.employeeShiftOffers,
            storeData.availableShiftsToCover,
            storeData.employeeShiftRequests,
            storeData.employeeMyShiftSwapOffers,
            storeData.availableShiftToSwapOffers,
            storeData.employeePaycodes,
            storeData.myProposals,
            storeData.availableOpenShifts,
            openShiftRequests,
            storeData.availableVTO,
            storeData.myVTORequests,
            statusDictionary,
            person.personName,
            managerSettings,
            dateRanges,
            globalConfigs.postedRequestDisplay,
        );
        await updateEmployeeDashboardData({
            monthlySchedule: monthlySchedule,
            openShiftRequests: openShiftRequests
        });
    }).catch(err => {
        let message = aux.handleAPIErrors(err.response)
        handleSnackbar.bind(this)('error', message, true)
    }).finally(() => {
        updateLoading(false);
    });
}

export async function refreshRetractRequestOpenShift(requestId) {
    const { options, statusDictionary, dateRanges, managerSettings, person, updateLoading, storeData, updateEmployeeDashboardData } = this.props;
    const { globalConfigs } = store.getState();

    let myOpenShiftRequests = storeData.myOpenShiftRequests
    let requestToUpdate = myOpenShiftRequests.find(x => x.id === requestId)
    let dateToReload = formatAs(requestToUpdate.startDate, DateFnsFormats.YMD);

    dotnet.getMyOpenShiftRequests(options, dateToReload, dateToReload).then(async myOpenShiftRequestsResponse => {
        for (const openShift of myOpenShiftRequestsResponse.data) {
            let index = myOpenShiftRequests.findIndex(x => x.id === openShift.id);
            if (index !== -1) {//2nd, 3rd request => replace
                myOpenShiftRequests[index] = openShift;
            }
            else {//first request => push
                myOpenShiftRequests.push(openShift);
            }
        }

        let monthlySchedule = UI.generateSchedule(true,
            storeData.employeeShifts,
            storeData.employeeShiftOffers,
            storeData.availableShiftsToCover,
            storeData.employeeShiftRequests,
            storeData.employeeMyShiftSwapOffers,
            storeData.availableShiftToSwapOffers,
            storeData.employeePaycodes,
            storeData.myProposals,
            storeData.availableOpenShifts,
            myOpenShiftRequests,
            storeData.availableVTO,
            storeData.myVTORequests,
            statusDictionary,
            person.personName,
            managerSettings,
            dateRanges,
            globalConfigs.postedRequestDisplay,
        );
        await updateEmployeeDashboardData({
            monthlySchedule: monthlySchedule,
            openShiftRequests: myOpenShiftRequests
        });
    }).catch(err => {
        let message = aux.handleAPIErrors(err.response)
        handleSnackbar.bind(this)('error', message, true)
    }).finally(() => {
        updateLoading(false);
    });

}


export async function refreshRequestVTO(managerSettingId) {//availableVTO.offerId is managerSetting.EntityId
    const { options, statusDictionary, dateRanges, managerSettings, person, updateLoading, storeData, updateEmployeeDashboardData } = this.props;
    const { globalConfigs } = store.getState();

    let availableVTO = storeData.availableVTO
    let offerRequested = availableVTO.find(x => x.offerId === managerSettingId);
    let dateToReload;
    if (offerRequested) {
        dateToReload = formatAs(offerRequested.timeOffStartDate, DateFnsFormats.YMD);
    }
    else {//it is a private VTO
        let privateOffer = storeData.privateOffers.find(x => x.offerId === managerSettingId);
        dateToReload = formatAs(privateOffer.timeOffStartDate, DateFnsFormats.YMD);
        refreshNotification.bind(this)(managerSettingId, false, false)
    }

    dotnet.getMyVTORequest(options, dateToReload, dateToReload).then(async myVTORequestsResponse => {
        let vtoRequestUpdated = myVTORequestsResponse.data.find(x => x.managerSettingId === managerSettingId)
        if (!myVTORequestsResponse.data || !myVTORequestsResponse.data.length || !vtoRequestUpdated) {
            return this.props.refreshData()//TODO KATH 4/14: this could happen when manager setting request period changes; find better fix
        }

        let myVTORequests = storeData.myVTORequests;
        for (const vto of myVTORequestsResponse.data) {
            let index = myVTORequests.findIndex(x => x.managerSettingId === vto.managerSettingId)
                ; if (index !== -1) {//2nd, 3rd request => replace
                    myVTORequests[index] = vto;
                }
            else {//first request => push
                myVTORequests.push(vto);
            }
        }

        let monthlySchedule = UI.generateSchedule(true,
            storeData.employeeShifts,
            storeData.employeeShiftOffers,
            storeData.availableShiftsToCover,
            storeData.employeeShiftRequests,
            storeData.employeeMyShiftSwapOffers,
            storeData.availableShiftToSwapOffers,
            storeData.employeePaycodes,
            storeData.myProposals,
            storeData.availableOpenShifts,
            storeData.myOpenShiftRequests,
            storeData.availableVTO,
            myVTORequests,
            statusDictionary,
            person.personName,
            managerSettings,
            dateRanges,
            globalConfigs.postedRequestDisplay,
        );
        await updateEmployeeDashboardData({
            monthlySchedule: monthlySchedule,
            myVTORequests: myVTORequests
        });
    }).catch(err => {
        let message = aux.handleAPIErrors(err.response)
        handleSnackbar.bind(this)('error', message, true)
    }).finally(() => {
        updateLoading(false);
    });
}

export async function refreshRetractRequestVTO(offerId) {
    const { options, statusDictionary, dateRanges, managerSettings, person, updateLoading, storeData, updateEmployeeDashboardData } = this.props;
    const { globalConfigs } = store.getState();
    let myVTORequests = storeData.myVTORequests;
    let index = myVTORequests.findIndex(x => x.offerId === offerId);
    let dateToReload = formatAs(myVTORequests[index].timeOffStartDate, DateFnsFormats.YMD);

    dotnet.getMyVTORequest(options, dateToReload, dateToReload).then(async myVTORequestsResponse => {
        let vtoRequestUpdated = myVTORequestsResponse.data.find(x => x.offerId === offerId)
        if (!myVTORequestsResponse.data || !myVTORequestsResponse.data.length || !vtoRequestUpdated) {
            return this.props.refreshData()//TODO KATH 4/14: this could happen when manager setting request period changes; find better fix
        }

        for (const vto of myVTORequestsResponse.data) {
            let index = myVTORequests.findIndex(x => x.offerId === vto.offerId)
                ; if (index !== -1) {//2nd, 3rd request => replace
                    myVTORequests[index] = vto;
                }
            else {//first request => push
                myVTORequests.push(vto);
            }
        }

        let monthlySchedule = UI.generateSchedule(true,
            storeData.employeeShifts,
            storeData.employeeShiftOffers,
            storeData.availableShiftsToCover,
            storeData.employeeShiftRequests,
            storeData.employeeMyShiftSwapOffers,
            storeData.availableShiftToSwapOffers,
            storeData.employeePaycodes,
            storeData.myProposals,
            storeData.availableOpenShifts,
            storeData.myOpenShiftRequests,
            storeData.availableVTO,
            myVTORequests,
            statusDictionary,
            person.personName,
            managerSettings,
            dateRanges,
            globalConfigs.postedRequestDisplay,
        );
        await updateEmployeeDashboardData({
            monthlySchedule: monthlySchedule,
            myVTORequests: myVTORequests
        });
    }).catch(err => {
        let message = aux.handleAPIErrors(err.response)
        handleSnackbar.bind(this)('error', message, true)
    }).finally(() => {
        updateLoading(false);
    });
}